
$(document).ready(function() {

    /* array for image source path */
    var images = [];

    /* array for image alternative text */
    var alternatives = [];

    /* domain */
    var domain = 'https://' + window.location.host + '/';

    /* count number of images */
    var count = $('.hotel_slider_image_src').length;

    var counter = 3;

    /* fill array width image source paths */
    $('.hotel_slider .hotel_slider_image_src').each(function(){
       images.push($(this).text());
    });

    /* fill array width image alternative texts */
    $('.hotel_slider .hotel_slider_image_alt').each(function(){
        alternatives.push($(this).text());
    });

    /* initial image load */
    function imgload() {
        $('.hotel_slider_image:nth-of-type(1)').attr("src", domain + "fileadmin" + images[count - 2]).attr("alt", alternatives[count - 2]);
        $('.hotel_slider_image:nth-of-type(2)').attr("src", domain + "fileadmin" + images[count - 1]).attr("alt", alternatives[count - 1]);
        $('.hotel_slider_image:nth-of-type(3)').attr("src", domain + "fileadmin" + images[0]).attr("alt", alternatives[0]);
        $('.hotel_slider_image:nth-of-type(4)').attr("src", domain + "fileadmin" + images[1]).attr("alt", alternatives[1]);
        $('.hotel_slider_image:nth-of-type(5)').attr("src", domain + "fileadmin" + images[2]).attr("alt", alternatives[2]);
    }

    imgload();

    /* slide left */
    function slide_left() {

        var new_image = '<img class="hotel_slider_image" src="' + domain + 'fileadmin' + images[counter] + '" alt="' + alternatives[counter] + '" />';

        if ($(window).outerWidth() <= 672) {
            $('.hotel_slider_container').animate({left:"-200%"},1200, function(){
                $('.hotel_slider_image:nth-of-type(1)').remove();
                $('.hotel_slider_container').append(new_image).css('left','-100%');
            });
        }
        else if ($(window).outerWidth() > 672) {
            $('.hotel_slider_container').animate({left:"-195%"},1200, function(){
                $('.hotel_slider_image:nth-of-type(1)').remove();
                $('.hotel_slider_container').append(new_image).css('left','-125%');
            });
        }


        /* set image counter for appending the next image */
        if(counter < count - 1) {
            counter++;
        }
        else {
            counter = 0;
        }
    }


    /* slide right */
    function slide_right() {

        var counter_back;
        if (counter === 0) {
            counter_back = count - 7;
        }
        else if (counter === 1) {
            counter_back = count - 6;
        }
        else if (counter === 2) {
            counter_back = count - 5;
        }
        else if (counter === 3) {
            counter_back = count - 4;
        }
        else if (counter === 4) {
            counter_back = count - 3;
        }
        else if (counter === 5) {
            counter_back = count - 2;
        }
        else if (counter === 6) {
            counter_back = count - 1;
        }
        else {
            counter_back = counter - 7;
        }

        var new_image = '<img class="hotel_slider_image" src="' + domain + 'fileadmin' + images[counter_back] + '" alt="' + alternatives[counter_back] + '" />';

        if ($(window).outerWidth() <= 672) {
            $('.hotel_slider_container').animate({left:"0"},1200, function(){
                $('.hotel_slider_image:last-of-type').remove();
                $('.hotel_slider_container').prepend(new_image).css('left','-100%');
            });
        }
        else if ($(window).outerWidth() > 672) {
            $('.hotel_slider_container').animate({left:"-55%"},1200, function(){
                $('.hotel_slider_image:last-of-type').remove();
                $('.hotel_slider_container').prepend(new_image).css('left','-125%');
            });
        }

        /* set image counter for appending the next image */
        if(counter === 0) {
            counter = count - 1;
        }
        else {
            counter--;
        }
    }

    /* automatic slider */

    /* initial slider interval start */
    var start = setInterval(automatic_slider, 5000);

    /* store timeout for automatic slider restart */
    var restart;


    function slider_interval() {
        start = setInterval(automatic_slider, 5000);
    }

    function slider_restart() {
        /* set timer for automatic restart after manual slider control */
        restart = setTimeout(slider_interval, 5000);
    }


    function automatic_slider() {
        slide_left();
    }

    function stop_automatic_slider() {
        clearInterval(start);
    }

    function stop_restart_automatic_timer() {
        clearTimeout(restart);
    }

    automatic_slider();


    /* slider controls */

    $('.hotel_slider_control_right').on('click', function(){
        /* clear restart timeout */
        stop_restart_automatic_timer();
        /* clear interval */
        stop_automatic_slider();
        /* finish the animation */
        $('.hotel_slider_container').finish();
        /* execute slide manually */
        slide_left();
        /* restart automatic slider */
        slider_restart();
    });

    if (count >= 7) {
        $('.hotel_slider_control_left').on('click', function(){
            /* clear restart timeout */
            stop_restart_automatic_timer();
            /* clear interval */
            stop_automatic_slider();
            /* finish the animation */
            $('.hotel_slider_container').finish();
            /* execute slide manually */
            slide_right();
            /* restart automatic slider */
            slider_restart();
        });
    }
    else {
        $('.hotel_slider_control_left').css('visibility','hidden');
    }



    /* swiping */

    if (count >= 7) {
        $('.hotel_slider').on('swiperight', function(){
            /* clear restart timeout */
            stop_restart_automatic_timer();
            /* clear interval */
            stop_automatic_slider();
            /* finish the animation */
            $('.hotel_slider_container').finish();
            /* execute slide manually */
            slide_right();
            /* restart automatic slider */
            slider_restart();
        });
    }

    $('.hotel_slider').on('swipeleft', function(){
        /* clear restart timeout */
        stop_restart_automatic_timer();
        /* clear interval */
        stop_automatic_slider();
        /* finish the animation */
        $('.hotel_slider_container').finish();
        /* execute slide manually */
        slide_left();
        /* restart automatic slider */
        slider_restart();
    });
});
